export const selectTagPage = state => state.tagPage.data
export const selectTagPageStatus = state => state.tagPage.status
